// extracted by mini-css-extract-plugin
export default {"button":"SocialLinkButton_button__RLyTG"};